module.exports = __webpack_public_path__ + "assets/img/class-leave.e646147a.png";